<template lang="jade">
  .container-fluid
    .row
      .log_main.col-md-12
        header.profile_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12 log
            span.deviceTime.col-md-3.pull-right.no_pad(v-if="$route.name === 'power'")
              |{{deviceTime}}
        section.function_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xxs
          .filter.input_group.col-lg-8.col-md-8.col-sm-6.col-xs-12
            .input_single.no_select(v-for="chk in checkedConditions")
              input.input_radio.form-control(type="checkbox" checked v-model="selectedOptions" v-bind:id="chk" v-bind:value='chk')
              label(v-bind:for='chk') {{chk}}
            .input_single
              input.input_radio.form-control(type="checkbox" v-model="selectAll" id="all")
              label(for='all') all
          .button_group.col-lg-4.col-md-4.col-sm-6.hidden-xs.clearfix
            button(v-on:click="clear()").btn.btn-danger.col-lg-5.col-md-5.col-offset-md-1.col-sm-12.col-xs-12.col-offset-xs-0
              i.fa.fa-trash-o
              |Clear
            a(v-el:download v-show=0)
            button(v-on:click="download()" v-if='!isMobile').btn.btn-info.col-lg-5.col-lg-offset-1.col-md-5.col-md-offset-1.col-sm-5.col-sm-offset-1
              i.fa.fa-download
              |Download
          //- ============== serach bar ======================
          .search_bar.col-lg-9.col-md-10.col-sm-12.col-xs-12.col-centered.clearfix.clear-left
            .title.col-lg-12.col-md-12.col-sm-12.col-xs-12.clearfix.clear-left
              .col-md-10.col-sm-10.col-xs-7.no_pad
                h2 Date range:
              .col-md-2.col-sm-2.col-xs-2.reset_filter_time
                button.btn.btn-default(@click="cleanFilterTime()")
                  | Clean Date
            .start_date.col-lg-6.clear-left.col-md-6.col-sm-6.col-sm-offset-0.col-xs-12
              label.col-md-3.col-xs-3 From:
              date-picker.col-md-9.col-xs-9(
                v-bind:time.sync="startDate"
                v-bind:option="startOption"
                v-on:click='blur'
                v-bind:limit.sync="limitStart")
            .end_date.col-lg-6.col-md-6.col-sm-6.col-sm-offset-0.col-xs-12
              label.col-md-3.col-xs-3 To:
              date-picker.col-md-9.col-xs-9(
                v-bind:time.sync="endDate"
                v-bind:option="endOption"
                v-on:click='blur'
                v-bind:limit.sync="limitEnd")
          //- pagination
          .pagination_section.col-md-12.col-sm-12.row_space--xs.no_pad-xxs.clearfix
            .col-md-9.col-sm-12.col-xs-12.col-centered.clearfix.no_pad-xxs
              .btn-group
                button.btn.btn-default.arrow(@click.prevent="setPage(currPage-1)" v-bind:disabled="currPage === 1")
                  span.glyphicon.glyphicon-chevron-left
                button.btn.btn-default.more(@click='setPaginationSec(currPaginationSec-1)' v-if='currPaginationSec !== 1')  ...
                button.btn.btn-default.page(@click.prevent="setPage(n+1)" v-for="n in totalPageAry | limitBy countOfPagination paginationStart" v-bind:class="{'active': (currPage === (n+1))}" )  {{n+1}}
                button.btn.btn-default.more(@click='setPaginationSec(currPaginationSec+1)' v-if='currPaginationSec !== totalSection')  ...
                button.btn.btn-default.arrow(@click.prevent="setPage(currPage+1)" v-bind:disabled="currPage === totalPage")
                  span.glyphicon.glyphicon-chevron-right
          //- ============== log table =======================
          .log_section.col-lg-12.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xxs
            .col-lg-9.col-md-10.col-sm-10.col-xs-12.col-centered.no_pad-xxs
              table.table.table-bordered.log_table
                tr
                  th Time
                  th Type
                  th Message
                tr(v-for="log in computedLog | orderBy 'dateTime' -1 | limitBy countOfPage pageStart ")
                  td.hidden-xs {{ log.dateTime | moment 'DD-MM-YYYY HH:mm:ss' }}
                  td.visible-xs {{ log.dateTime | moment 'DD-MM-YYYY' }}
                    //- br {{log.dateTime | moment 'HHMMSS'}}
                  td {{ log.type }}
                  td.logMsg
                    span.trigger(v-on:click.stop='toggleMsg($event)')
                      | {{ log.message }}
            .button_group.mobile_button_group.col-lg-6.col-md-6.col-sm-6.visible-xs.col-xs-12
              button(v-on:click="clear").btn.btn-danger.col-xs-12
                i.fa.fa-trash-o
                |Clear
              //- button(v-on:click="download()").btn.btn-info.col-xs-12
                i.fa.fa-download
                |Download
      modal.confrim_modal(
        title="Confirm"
        v-bind:show.sync= "showConfirm"
        effect= "zoom"
        v-bind:callback='confirmCb'
        ok-text="Yes"
        cancel-text="Cancel")
          .modal-body(slot='modal-body').clearfix {{ confirmMsg }}
</template>

<script>
import $ from 'jquery'
import Service from 'src/Service'
import datePicker from 'vue-datepicker/vue-datepicker-1.vue'
import { modal } from 'vue-strap'
import _ from 'lodash'
import moment from 'moment'
import MobileDetect from 'mobile-detect'
import pagiNation from '../components/Pagination.vue'
import VV from '__vendor_variables_js__'
const longDataFormat = 'DD-MM-YYYY HH:mm:ss'
const shortDateFormat = 'DD-MM-YYYY'
export default {
  components: {
    'date-picker': datePicker,
    'v-pagination': pagiNation,
    modal
  },
  data () {
    return {
      // events: events,
      startDate: '',
      endDate: '',
      downloadlink: '',
      selectedOptions: [],
      startOption: {
        type: 'day',
        SundayFirst: true,
        week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: shortDateFormat,
        placeholder: 'Select a start date',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '14px',
          'font-family': 'Avenir',
          'font-weight': '400',
          'width': '100%',
          'border': '2px solid transparent',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
          '-o-box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
          '-webkit-box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
          'border-radius': '2px',
          'background-color': '#fff',
          'color': 'transparent',
          'text-shadow': '0 0 0 #5f5f5f',
          '::-webkit-input-placeholder': '#aaa',
          '::-moz-input-placeholder': '#aaa',
          '::-ms-input-placeholder': '#aaa',
          '::-o-input-placeholder': '#aaa',
          'cursor': 'text',
          'outline': '1px solid #aaa'
        },
        color: {
          header: VV.color.theme,
          headerText: '#fff'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancel'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      showConfirm: false,
      confirmMsg: '',
      confirmCb: function () {},
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      timezone: {},
      currentTime: '',
      isSwitcher: false
    }
  },
  asyncData () {
    Service.call(this.$route.params.mac, 'dxGetTimeZone').then(({timezone}) => {
      this.timezone = timezone
      this.updateTime()
      return Service.call(this.$route.params.mac, 'dxGetAbout')
    }).then(({model}) => {
      this.isSwitcher = model.toUpperCase().includes('SW')
      this.$dispatch('updateIsSwitcher', model.toUpperCase().includes('SW'))
      console.log('isSwitcher =>', this.isSwitcher)
    })
    .catch(err => {
      this.alert('danger', 'No response', err)
    })
  },
  firebase () {
    return {
      events: Service.getEventLogRef(this.$route.params.mac).limitToLast(3000)
    }
  },
  computed: {
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(longDataFormat)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(longDataFormat)
      }
    },
    isMobile () {
      let md = new MobileDetect(window.navigator.userAgent)
      return md.mobile() !== null
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    paginationStart () {
      return (this.currPaginationSec - 1) * this.countOfPagination
    },
    totalSection () {
      return Math.ceil(this.totalPage / this.countOfPagination)
    },
    totalPage () {
      return Math.ceil(this.computedLog.length / this.countOfPage)
    },
    totalPageAry () {
      let ary = []
      for (let i = 0; i < this.totalPage; i++) {
        ary.push(i)
      }
      return ary
    },
    limitStart () {
      return this.endDate ? [{
        type: 'fromto',
        from: '2010-01-01',
        to: moment(this.endDate, shortDateFormat)
        // .format('YYYY-MM-DD')
      }] : []
    },
    limitEnd () {
      return this.startDate ? [{
        type: 'fromto',
        from: moment(this.startDate, shortDateFormat).format('YYYY-MM-DD'),
        to: '2100-12-31'
      }] : []
    },
    selectAll: {
      get () {
        return this.selectedOptions.length === this.checkedConditions.length
      },
      set (value) {
        this.selectedOptions = value ? _.cloneDeep(this.checkedConditions) : []
      }
    },
    checkedConditions () {
      if (this.$route.name === 'power') {
        return [
          'lock',
          'enable',
          'info',
          'reset',
          'maintenance'
        ]
      } else if (this.$route.name === 'matrix') {
        let filters = [
          'links',
          'quality',
          'power',
          'mapping',
          'hdcp',
          'edid',
          'maps',
          'info',
          'maintenance'
        ]
        if (this.isSwitcher) filters.push('switcherLayout')
        return filters
      } else if (this.$route.name === 'mixer') {
        return [
          'mapping',
          'layer',
          'split',
          'label',
          'preset',
          'sound',
          'video',
          'color',
          'crop',
          'maintenance',
          'links',
          'hdcp',
          'edid'
        ]
      } else if (this.$route.name === 'dio') {
        return [
          'state',
          'info',
          'maintenance'
        ]
      } else if (this.$route.name === 'splitter') {
        return [
          'split',
          'preset',
          'resolution',
          'maintenance'
        ]
      }
    },
    endOption () { // reduce the option for end date
      let opt = _.cloneDeep(this.startOption)
      opt.placeholder = 'Select a end date'
      return opt
    },
    computedLog () {
      let events = null
      if (this.startDate && this.endDate) {
        let startMoment = moment(this.startDate, shortDateFormat)
        let endMoment = moment(this.endDate, shortDateFormat)
        events = this.events.filter(e => moment(e.dateTime).isBetween(startMoment, endMoment, 'days', '[]'))
      } else {
        events = this.events
      }
      events = events.map(evt => {
        let devTime = 0
        let offset = moment.parseZone(moment(this.currentTime).utcOffset())  // minutes
        if (this.$route.name === 'power') {  // show the log using device timezone
          if (this.timezone.useDaylight) {
            devTime = evt.dateTime - offset * 60000 + (this.timezone.offset + this.timezone.dstSavings) * 1000
          } else {
            devTime = evt.dateTime - offset * 60000 + this.timezone.offset * 1000
          }
          return {
            dateTime: devTime, // this if for html showing
            timeString: moment(devTime, shortDateFormat).format(longDataFormat), // this is for download csv shows
            type: evt.type,
            message: evt.msg
          }
        } else {
          return {
            dateTime: evt.dateTime, // this if for html showing
            timeString: moment(evt.dateTime, shortDateFormat).format(longDataFormat), // this is for download csv shows
            type: evt.type,
            message: evt.msg
          }
        }
      })
      return events.filter(evt => this.selectedOptions.indexOf(evt.type) > -1)
    },
    logLength () {
      return this.computedLog.length
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      if (type === 'timezone') {
        this.timezone = event.timezone
      }
    }
  },
  methods: {
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    },
    setPage: function (idx) {
      if (idx <= 0 || idx > this.totalPage) {
        return
      }
      this.currPage = idx
      if (idx > this.currPaginationSec * this.countOfPagination) {
        this.setPaginationSec(this.currPaginationSec + 1)
      } else if (idx <= (this.currPaginationSec - 1) * this.countOfPagination) {
        this.setPaginationSec(this.currPaginationSec - 1)
      }
    },
    setPaginationSec (idx) {
      if (idx <= 0 || idx > this.totalSection) {
        return
      }
      this.currPaginationSec = idx
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    toggleMsg (e) {
      if ($(e.target).hasClass('open')) {
        $(e.target).removeClass('open')
      } else {
        $(e.target).addClass('open')
      }
    },
    clear () {
      this.handleConfirmModal('This will CLEAR all logs of this device, do you want to continue?', () => {
        Service.clearEvents(this.$route.params.mac)
        this.alert('success', '', 'Logs have been cleaned')
      })
    },
    handleConfirmModal (msg, callback) {
      let confirmCb = () => {
        callback()
        this.showConfirm = false
      }
      this.confirmMsg = msg
      this.confirmCb = confirmCb
      this.showConfirm = true
    },
    download () {
      const csvTitles = ['Time', 'Type', 'Message']
      const dataKeys = ['dateTime', 'type', 'message']
      let csvContent = csvTitles.join() + '\r\n'
      let csvToDown = this.computedLog
      for (let column of csvToDown) {
        let columnData = dataKeys.map(k => {
          if (k === 'dateTime') {
            return moment(column[k]).format(longDataFormat)
          } else {
            return column[k]
          }
        })
        csvContent = csvContent + columnData.join() + '\r\n'
      }
      let textFileAsBlob = new window.Blob([csvContent], {type: 'text/plain'})
      let atag = this.$els.download
      atag.download = 'exportLog.csv'
      atag.href = window.URL.createObjectURL(textFileAsBlob)
      try {
        atag.click()
      } catch (e) {  // throws when IE
        window.navigator.msSaveBlob(textFileAsBlob, 'exportLog.csv')
      }
    },
    blur (evt) {
      $(evt.target).blur() // to disable blinking cursor on mobile
    },
    cleanFilterTime () {
      this.startDate = ''
      this.endDate = ''
    }
  }
}
</script>

<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  section,header{
    /* border-bottom:1px solid $section_border_bottom_color ; */
    &:last-child{
      border:none;
    }
  }
  .log_table{
    & .logMsg{
      max-width: 300px;
      @include breakpoint(iSixPlus) {
        max-width: 220px;
      }
      @include breakpoint(iSix) {
        max-width: 180px;
      }
      @include breakpoint(iFive) {
        max-width: 130px;
      }
    }
    text-align:center;
    th {
      text-align:center;
    }
    @include breakpoint(sm) {
      font-size: 18px;
    }
    @include breakpoint(xxs) {
      font-size: 12px;
    }
    td{
      width: 33%;
    }
    & .trigger{
      cursor: pointer;
      display: inline-block;
      overflow-x: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
    & .trigger.open{
      white-space: normal;
    }
  }
  .filter{
    text-transform: capitalize;
    .input_single{
      float: left;
      padding:2px 1%;
      font-size: 14px;
      @include breakpoint(xxs){
        font-size: 14px;
      }
    }
  }
  .search_bar{
    padding-top: 5px;
    font-size: 16px;
    
    .title{
      white-space:nowrap;
      h2{
        margin-top: 0;
        margin-bottom: 28px;
      }
    }
    
    .reset_filter_time{
      height: 100%;
    }

    label{
      white-space:nowrap;
    }

    .start_date,.end_date{
      padding-left: 2px;
     
      @include breakpoint(iFive){
        margin-bottom: 10px;
      }
    }
  }
  .button_group{
    .btn{
      font-size: 18px;
      .fa{
        margin-right: 5px;
      }
    }
  }

  .mobile_button_group{
    .btn{
      margin-bottom:15px;
    }
  }


  /* checkbox styling */
  /* Base for label styling */
  [type="checkbox"]:not(:checked),
  [type="checkbox"]:checked {
    position: absolute;
    left: -9999px;
  }
  [type="checkbox"]:not(:checked) + label,
  [type="checkbox"]:checked + label {
    position: relative;
    padding-left: 25px;
    cursor: pointer;
  }

  /* checkbox aspect */
  [type="checkbox"]:not(:checked) + label:before,
  [type="checkbox"]:checked + label:before {
    content: '';
    position: absolute;
    left:0; top: 2px;
    width: 17px; height: 17px;
    border: 1px solid #aaa;
    background: #f8f8f8;
    border-radius: 3px;
    box-shadow: inset 0 1px 3px rgba(0,0,0,.3);
  }
  /* checked mark aspect */
  [type="checkbox"]:not(:checked) + label:after,
  [type="checkbox"]:checked + label:after {
    content: '✔';
    position: absolute;
    top: 3px; left: 4px;
    @include breakpoint(iFive){
      left:2px;
      top: 5px;
      font-size: 14px;
    }
    line-height: 0.8;
    color: #09ad7e;
    transition: all .2s;
  }
  /* checked mark aspect changes */
  [type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
  }
  .pagination_section{
    & button{
      @include breakpoint(iSixPlus) {
        padding: 5px;
      }
      @include breakpoint(iSix) {
        padding:  5px;
      }
      @include breakpoint(iFive){
        padding: 3px;
      }
    }
    & button{
      outline:none;
      &:focus{
        outline:none
      }
    }
    padding: 15px 7px;
    text-align: center;
    .more {
      width: 50px;
      @include breakpoint(xs) {
        width: 30px;
      }
    }
    .arrow {
      width: 80px;
      @include breakpoint(xs) {
        width: 45px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Log.vue?5114373a